import { apiCall } from "@/shared/lib/api-call";
import { apiPaths } from "@/shared/lib/api-paths";
import {
  type DirectoryListResponse,
  directoryListResponseSchema,
  type ListDirectoryQuery,
} from "@/shared/membership/directory.schema";

/// HTTP boundary for the cross-feature directory read. Sliced out of
/// features/people/people.api.ts in the C2 deepening, feedback,
/// kudos, one-on-one, todos all need this read for their pickers.
/// The other people endpoints (stats, detail, HR, bulk, departments,
/// imports) stay in features/people/people.api.

function toQueryString(query: Partial<ListDirectoryQuery>): string {
  const params = new URLSearchParams();
  if (query.cursor) params.set("cursor", query.cursor);
  if (query.limit !== undefined) params.set("limit", String(query.limit));
  if (query.sortBy) params.set("sortBy", query.sortBy);
  if (query.sortDir) params.set("sortDir", query.sortDir);
  if (query.search) params.set("search", query.search);
  if (query.role) params.set("role", query.role);
  if (query.employmentType) params.set("employmentType", query.employmentType);
  if (query.workMode) params.set("workMode", query.workMode);
  if (query.channel) params.set("channel", query.channel);
  if (query.addedVia) params.set("addedVia", query.addedVia);
  if (query.departmentId) params.set("departmentId", query.departmentId);
  if (query.status) params.set("status", query.status);
  const qs = params.toString();
  return qs.length ? `?${qs}` : "";
}

export function listPeople(
  workspaceId: string,
  query: Partial<ListDirectoryQuery> = {},
): Promise<DirectoryListResponse> {
  return apiCall(
    `${apiPaths.people.list(workspaceId)}${toQueryString(query)}`,
    { method: "GET" },
    directoryListResponseSchema,
  );
}
